import client from '../../client'
import { prefectures } from './constants'
import { ListPrefecturesResponse, PrefectureId } from './types'

export * from './types'

export const list = async () => {
  const data: ListPrefecturesResponse = await client.get(`/user/prefectures`)
  return data
}

export const getSync = (id: PrefectureId) =>
  prefectures.find(({ id: prefId }) => prefId === id)

export const get = (id: PrefectureId) => Promise.resolve(getSync(id))
